export interface EstadoEditavelProposta {
  titulo: string;
  status: string;
  revisao: number;
  dados: unknown;
  itensVenda: unknown[];
}

// Compara somente os campos que a tela de edição pode alterar. Metadados que
// mudam no servidor (atualizado_em, composição vinculada etc.) não devem fazer
// a tela acusar uma edição inexistente.
export function propostaTemAlteracoes(
  documento: any,
  estadoAtual: EstadoEditavelProposta,
  dadosPadrao: unknown = {},
): boolean {
  if (!documento) return false;
  const original: EstadoEditavelProposta = {
    titulo: documento.titulo || '',
    status: documento.status || 'rascunho',
    revisao: documento.revisao || 0,
    dados: documento.dados_estruturados || dadosPadrao,
    itensVenda: Array.isArray(documento.itens_venda) ? documento.itens_venda : [],
  };
  return serializarEstado(original) !== serializarEstado(estadoAtual);
}

// A resposta do PUT contém o documento inteiro que estava salvo no servidor.
// Durante a edição, porém, textos e itens mais novos ainda existem só na tela.
// Por isso mesclamos apenas os metadados do vínculo, sem trazer de volta o
// conteúdo antigo e apagar o rascunho em andamento.
export function mesclarVinculoComposicao(
  documento: any,
  composicaoId: string | null,
  respostaServidor?: any,
): any {
  if (!documento) return documento;
  return {
    ...documento,
    composicao_id: composicaoId,
    atualizado_em: respostaServidor?.atualizado_em || documento.atualizado_em,
    composicao_desatualizada:
      respostaServidor?.composicao_desatualizada ?? documento.composicao_desatualizada,
  };
}

// Usado também pelo editor de composição para comparar o retrato carregado
// com o estado atual sem acoplar o componente a uma biblioteca de formulários.
export function serializarEstado(valor: unknown): string {
  return JSON.stringify(valor);
}
